import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";

import "./Styles/index.css";
import "./Helpers/Axios"

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <div className="app">
      <App />
    </div>
  </StrictMode>,
);